module.exports = __webpack_public_path__ + "static/media/service-end-notification.d00f3c6c.mp3";